/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_Field_Base_UrlInputs */

const en_byoa_field_base_url = /** @type {(inputs: Byoa_Field_Base_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service address`)
};

const id_byoa_field_base_url = /** @type {(inputs: Byoa_Field_Base_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat layanan`)
};

/**
* | output |
* | --- |
* | "Service address" |
*
* @param {Byoa_Field_Base_UrlInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_field_base_url = /** @type {((inputs?: Byoa_Field_Base_UrlInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Field_Base_UrlInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_field_base_url(inputs)
	return en_byoa_field_base_url(inputs)
});